export default __webpack_public_path__ + "static/media/faceDetectionPreview.5b004dc3.webp";